export default function capitalizeFirstLetter(text) {
    return text?.toLowerCase()?.split('. ')?.map(sentence => {
        if (sentence && sentence.length > 0) {
            return sentence.charAt(0).toUpperCase() + sentence.slice(1);
        }
        return sentence; // Return the sentence as is if it's empty or invalid
    }).join('. ');
}
